import {
  FormFieldConfigType,
  INPUT_TYPES,
  TEXT_INPUT_TYPES,
  RADIO_YES_NO,
} from "../../../../types";
import { ADDITIONAL_INFORMATION_CONSTANTS } from "../../../constants";
import { preProcessFormFields } from "../../../../tools";
import { INSTALLATION_SOURCE_OPTIONS, TACT_COUNTRIES } from "../../../options";

export const formFieldsConfig: FormFieldConfigType[] = [
  {
    name: "allAdditionalInformationFields",
    type: INPUT_TYPES.FIELD_GROUP,
    contained: true,
    label: "Additional Information",
    fields: [
      {
        name: ADDITIONAL_INFORMATION_CONSTANTS.INSTALLATION_SOURCE,
        label: "If the item was installed, was it by Amazon or a third-party?",
        description: "",
        type: INPUT_TYPES.SELECT,
        placeholderText:
          "Select If the item was installed, was it by Amazon or a third-party?",
        options: INSTALLATION_SOURCE_OPTIONS,
      },
      {
        name: ADDITIONAL_INFORMATION_CONSTANTS.PRODUCT_LINK,
        label: "Product Listing Link",
        description: "",
        type: INPUT_TYPES.TEXT,
        placeholderText: "Please enter Product Listing Link",
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
      },
      {
        name: ADDITIONAL_INFORMATION_CONSTANTS.ERC_OFFER_AMOUNT,
        label: "Amount Offered by ERC to the Customer",
        description: "",
        type: INPUT_TYPES.TEXT,
        placeholderText: "Please enter Amount Offered by ERC to the Customer",
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
      },
      {
        name: ADDITIONAL_INFORMATION_CONSTANTS.ITEM_RETURNED,
        label: "Was item returned to Amazon?",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: RADIO_YES_NO,
        onChange: (
          { detail }: { detail: any },
          formState: any,
          updateForm: (formState: any) => void,
        ) => {
          const hidden = detail.value === "false";
          updateForm({
            ...formState,
            [ADDITIONAL_INFORMATION_CONSTANTS.ITEM_RETURNED]: {
              ...formState[ADDITIONAL_INFORMATION_CONSTANTS.ITEM_RETURNED],
              value: detail.value,
            },
            [ADDITIONAL_INFORMATION_CONSTANTS.AMAZON_LOCATION]: {
              ...formState[ADDITIONAL_INFORMATION_CONSTANTS.AMAZON_LOCATION],
              hidden,
            },
            [ADDITIONAL_INFORMATION_CONSTANTS.RETURN_CENTER_POC]: {
              ...formState[ADDITIONAL_INFORMATION_CONSTANTS.RETURN_CENTER_POC],
              hidden,
            },
            [ADDITIONAL_INFORMATION_CONSTANTS.ADVISED_DISPOSAL]: {
              ...formState[ADDITIONAL_INFORMATION_CONSTANTS.ADVISED_DISPOSAL],
              hidden,
            },
          });
        },
      },
      {
        name: ADDITIONAL_INFORMATION_CONSTANTS.AMAZON_LOCATION,
        label: "Amazon Location (ex. SEA41)",
        description: "",
        type: INPUT_TYPES.TEXT,
        placeholderText: "Please enter Amazon Location (ex. SEA41)",
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
      },
      {
        name: ADDITIONAL_INFORMATION_CONSTANTS.RETURN_CENTER_POC,
        label: "Site POC for the Amazon Return Center (Name and Amazon Alias)",
        description: "",
        type: INPUT_TYPES.TEXT,
        placeholderText:
          "Please enter Site POC for the Amazon Return Center (Name and Amazon Alias)",
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
      },
      {
        name: ADDITIONAL_INFORMATION_CONSTANTS.ADVISED_DISPOSAL,
        label: "Did Amazon advise to dispose of the product?",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: RADIO_YES_NO,
      },
      {
        name: ADDITIONAL_INFORMATION_CONSTANTS.SELLER_CONTACT_DETAILS,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: true,
        header: "Seller Contact Details",
        label: "Seller Contact Details",
        fields: [
          {
            name: ADDITIONAL_INFORMATION_CONSTANTS.ADDRESS_LINE_1,
            label: "Address Line 1",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
            placeholderText: "",
          },
          {
            name: ADDITIONAL_INFORMATION_CONSTANTS.ADDRESS_LINE_2,
            label: "Address Line 2",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
            placeholderText: "",
          },
          {
            name: ADDITIONAL_INFORMATION_CONSTANTS.CITY,
            label: "City",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
            placeholderText: "",
          },
          {
            name: ADDITIONAL_INFORMATION_CONSTANTS.COUNTRY,
            label: "Country",
            type: INPUT_TYPES.SELECT,
            options: TACT_COUNTRIES,
            placeholderText: "Select a country",
          },
          {
            name: ADDITIONAL_INFORMATION_CONSTANTS.PHONE,
            label: "Phone",
            type: INPUT_TYPES.PHONE,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
            placeholderText: "",
          },
          {
            name: ADDITIONAL_INFORMATION_CONSTANTS.EMAIL,
            label: "Email",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
            placeholderText: "",
          },
        ],
      },
      {
        name: ADDITIONAL_INFORMATION_CONSTANTS.REPORTED_TO_PR,
        label: "Has this claim been reported to Amazon Public Relations (PR)?",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: RADIO_YES_NO,
      },
    ],
  },
];

export const formFieldsConfigProcessed = preProcessFormFields(formFieldsConfig);
